<template>
  <!-- Header -->
  <div>
    <fixed-header
      id="js-header"
      class="u-header"
      :fixed.sync="isFixed"
      :threshold="50"
    >
      <div class="u-header__section temp-header" :class="{ header: isFixed }">
        <!-- Topbar -->
        <div
          class="g-bg-main main-header"
          :class="{ 'is-collapse': isCollapse }"
        >
          <router-link :to="{ name: 'Home' }">
            <img
              src="../../..//static/assets/img/logo/ChampionsForSight_PrimaryLogo_White.png"
              class="evf_logo"
              :class="{ evf_logo_height: !isLogIn }"
            />
          </router-link>
          <a v-if="accountType == 'master'" href="#"
            ><img v-if="isLogIn" class="major-sponsor-sm" :src="cltl_logo_white"
          /></a>
          <span v-else-if="sponsors != null">
            <a
              target="_blank"
              v-if="sponsors.hyperLinkMajor != ''"
              :href="sponsors.hyperLinkMajor"
              ><img
                v-if="isLogIn && sponsors.majorLogo"
                class="major-sponsor-sm"
                :src="sponsors.majorLogo"
            /></a>
            <a target="_blank" v-if="sponsors.hyperLinkMajor == ''"
              ><img
                v-if="isLogIn && sponsors.majorLogo"
                class="major-sponsor-sm"
                :src="sponsors.majorLogo"
            /></a>
          </span>
          <span v-else
            ><a
              ><img
                v-if="isLogIn && sponsors.majorLogo"
                class="major-sponsor-sm"
                :src="sponsors.majorLogo"/></a
          ></span>
           <!-- Login button container added here -->
           <div v-if="!isLogIn" class="login-button-container">
            <span class="g-px-10 g-color-white">Already have an account?</span>
            <button class="login-button" @click="redirectToLogin">
              Login
            </button>
          </div>
          <div
            class="hamburger-div"
            v-on:click="isCollapse = !isCollapse"
          ></div>
          <div class="collapse-button" v-if="isLogIn">
            <!-- <span class="collapse-line"></span>
            <span class="collapse-line" style="top: 11px"></span>
            <span class="collapse-line" style="top: 22px"></span> -->

            <span class="g-color-white" style="font-size: 30px"
              ><i class="fa fa-bars"></i
            ></span>
          </div>
          <transition name="fade" v-if="isCollapse">
            <div class="nav-collapse">
              <ul class="navigation-bar-collapse" v-if="isLogIn">
                <br />
                <div>
                  <!-- Links -->
                  <li>
                    <a
                      v-on:click="RouterRedirect('Home')"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >Home</a
                    >
                  </li>
                  <li>
                    <a
                      v-on:click="showOrderSubMenuOnMobile = !showOrderSubMenuOnMobile"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >Order</a
                    >
                  </li>
                  <template v-if="showOrderSubMenuOnMobile">
                    <li>
                      <a 
                        class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                        v-on:click="RouterRedirect('Order')">Patient Order</a>
                    </li>
                    <li>
                      <a 
                        class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                        v-on:click="RouterRedirect('FramesCenter')">Frame Collection</a>
                    </li>
                    <li>
                      <a 
                        class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                        v-on:click="RouterRedirect('OrderTracking')">Track Order</a>
                    </li>
                  </template>
                  <li
                    v-if="
                      this.framePageVisible == 'true' ||
                        MasterAccountType == 'master'
                    "
                  >
                    <a
                      v-on:click="RouterRedirect('FramesCenter')"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >Frames</a
                    >
                  </li>
                  <li>
                    <a
                      v-on:click="RouterRedirect('Resource')"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >Resources</a
                    >
                  </li>
                  <li>
                    <a
                      v-on:click="RouterRedirect('UserAccount')"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >My Account</a
                    >
                  </li>
                  <li>
                    <a
                      v-on:click="RouterRedirect('Help')"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >Help</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://onesightus.donorsupport.co/page/practicechampions"
                      target="_blank"
                      rel="noopener"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                    >Donate</a>
                  </li>
                  <li>
                    <a
                      v-on:click="LogOut()"
                      class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-12 text-uppercase g-px-10 g-py-15"
                      >Log Out</a
                    >
                  </li>
                </div>
                <!-- End Links -->
              </ul>
              <br />
            </div>
          </transition>
          <div class="container g-py-15 nav-container">
            <ul class="navigation-bar" v-if="isLogIn">
              <div>
                <!-- Links -->
                <li class="nav-item list-inline-item d-none d-lg-inline-block">
                  <a
                    v-on:click="RouterRedirect('PortalHome')"
                    :class="{ isActive: isActive == 'home' }"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >Home</a
                  >
                </li>
                <li class="nav-item order-dropdown list-inline-item d-none d-lg-inline-block">
                  <a
                    :class="{ isActive: isActive == 'order' }"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >Order</a
                  >
                  <ul class="order-sub-menu position-absolute bg-white list-unstyled px-4 py-2 mt-2">
                    <li>
                      <a 
                        class="u-link-v5 g-font-size-15"
                        v-on:click="RouterRedirect('Order')">Patient Order</a>
                    </li>
                    <li>
                      <a 
                        class="u-link-v5 g-font-size-15"
                        v-on:click="RouterRedirect('FramesCenter')">Frame Collection</a>
                    </li>
                    <li>
                      <a 
                        class="u-link-v5 g-font-size-15"
                        v-on:click="RouterRedirect('OrderTracking')">Track Order</a>
                    </li>
                  </ul>
                </li>
                <li
          
                  class="nav-item list-inline-item d-none d-lg-inline-block"
                >
                  <a
                    v-on:click="RouterRedirect('FramesCenter')"
                    :class="{ isActive: isActive == 'frame' }"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >Frames</a
                  >
                </li>
                <li class="nav-item list-inline-item d-none d-lg-inline-block">
                  <a
                    v-on:click="RouterRedirect('Resource')"
                    :class="{ isActive: isActive == 'resource' }"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >Resources</a
                  >
                </li>
                <li class="nav-item list-inline-item d-none d-lg-inline-block">
                  <a
                    v-on:click="RouterRedirect('UserAccount')"
                    :class="{ isActive: isActive == 'my-account' }"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >My Account</a
                  >
                </li>
                <li class="nav-item list-inline-item d-none d-lg-inline-block">
                  <a
                    v-on:click="RouterRedirect('Help')"
                    :class="{ isActive: isActive == 'help' }"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >Help</a
                  >
                </li>
                <li class="nav-item list-inline-item d-none d-lg-inline-block">
                  <a
                    href="https://onesightus.donorsupport.co/page/practicechampions"
                    target="_blank"
                    rel="noopener"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                  >Donate</a>
                </li>
                <li class="nav-item list-inline-item d-none d-lg-inline-block">
                  <a
                    v-on:click="LogOut()"
                    class="u-link-v5 g-color-white-opacity-0_7 g-color-white--hover g-font-size-15 text-uppercase g-px-10 g-py-18"
                    >Log Out</a
                  >
                </li>
              </div>
              <!-- End Links -->
            </ul>
          </div>
        </div>
        <!-- End Topbar -->
        <div
          v-if="
            AccountStatus == 'OrderHoldUnderReview' &&
              showTheNotificationAlert == 'false' &&
              activeCurrentPage == 'order'
          "
          class="g-bg-main g-py-10"
        >
          <div class="col-lg-8 offset-lg-2">
            <div
              id="successDiv"
              class="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              <strong
                >This account is unable to place orders at this time.</strong
              >
            </div>
          </div>
        </div>
        <div class="g-py-10" v-if="showTheNotificationAlert == 'true'">
          <div class="col-lg-10 offset-lg-1">
            <div
            v-if="notificationMessage != 'null'"
              id="successDiv"
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
            >
              <a
                v-on:click="hideNotificationAlert()"
                class="close"
                data-dismiss="alert"
                aria-label="close"
                >&times;</a
              >{{ notificationMessage }}
            </div>
          </div>
        </div>
      </div>
    </fixed-header>
    <div style="height: 110px; background: #26304d !important;"></div>
  </div>
</template>
<script>
import FixedHeader from "vue-fixed-header";
export default {
  components: { FixedHeader },
  data() {
    return {
      isLogIn: false,
      IsNavbarShown: true,
      AccountStatus: null,
      isFixed: false,
      isCollapse: false,
      showOrderSubMenuOnMobile: false,
      activeCurrentPage: localStorage.getItem("is-active"),
      isActive: false,
      MasterAccountType: null,
      framePageVisible: localStorage.getItem("frameAndLensOrderIsAllowed"),
      notificationMessage: localStorage.getItem(
        "PersistentNotificationMessage"
      ) ,
      countDownTimer: null,
      showTheNotificationAlert: localStorage.getItem(
        "ShowPersistentNotification"
      )
    };
  },
  methods: {
    LogOut() {
      this.$router.push({ name: "Home" });
      var activePage = localStorage.getItem("is-active");
      var x = 0;
      if (activePage == "order") {
        new Promise(resolve => {
          this.countDownTimer = setInterval(() => {
            if (localStorage.getItem("logout_session_acc")) {
              resolve(localStorage.getItem("logout_session_acc"));
            }
          }, 1000);
        }).then(isLogout => {
          clearInterval(this.countDownTimer);
          if (isLogout == "true") {
            this.RemoveItems();
            this.isLogIn = false;
            location.reload();
          }
        });
      } else {
        this.RemoveItems();
        this.isLogIn = false;
        location.reload();
      }
    },
    hideNotificationAlert() {
      localStorage.setItem("ShowPersistentNotification", false);
      this.showTheNotificationAlert = false;
    },
    RemoveItems() {
      localStorage.removeItem("host");
      localStorage.removeItem("PersistentNotification");
      localStorage.removeItem("token");
      localStorage.removeItem("watchword");
      localStorage.removeItem("accountType");
      localStorage.removeItem("accountStatus");
      localStorage.removeItem("frameAndLensOrderIsAllowed");
      localStorage.removeItem("is-active");
      localStorage.removeItem("orderTrackingList");
      localStorage.removeItem("resultCount");
      localStorage.removeItem("orderObj");
      localStorage.removeItem("nextURL");
      localStorage.clear();
      console.log(localStorage);
    },
    CheckLogin() {
      if (localStorage.getItem("token")) {
        this.isLogIn = true;
      }
    },
    RouterRedirect(name) {
      if (this.$route.name === name) {
        if (name === "Home") {
          this.$router.push({ name: "HomePage" });
        } else {
          this.$router.go(0);
        }
      } else {
        this.$router.push({ name: name });
      }
    },
    redirectToLogin() {
      this.$router.push({ name: "Login" });
    }
  },
  created() {
    this.CheckLogin();
    this.MasterAccountType = localStorage.getItem("accountType");
    this.AccountStatus = localStorage.getItem("accountStatus");
    this.isActive = localStorage.getItem("is-active");
    // alert(this.isActive);
  }
};
</script>
<style scoped>
.login-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  margin-left: auto; /* Pushes the login button to the far right */
}

.login-button {
  background-color: var(--secondary-color);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  margin-right: 30px;
  cursor: pointer;
}

.login-button:hover {
  background-color: var(--primary-color);
}

/* Flexbox properties for the header */
.main-header {
  display: flex;
  align-items: center; /* Center children vertically */
}

.order-sub-menu {
  display: none;
  border-radius: 2px;
}

.order-sub-menu li {
  margin-bottom: 5px;
}
.order-dropdown:hover ul.order-sub-menu {
  display: block!important;
}

ul.order-sub-menu a {
  color: #000;
}

</style>


// WEBPACK FOOTER //
// HeaderComponent.vue?d07e72d6